import React, { useEffect, useState } from "react";
import {
  Container,
  Paper,
  Typography,
  Select,
  MenuItem,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  Button,
} from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import DashboardLayout from "../../layouts/DashboardLayout";
import { useDispatch, useSelector } from "react-redux";
import { getSupportOverview } from "../../redux/actions/dashboard";
import { useNavigate, useParams } from "react-router-dom";
import {
  superAdminCompanyOverviewDetails,
  superAdminUserOverviewDetails,
} from "../../redux/actions";
import CeroTable from "../../components/CeroTable";
import useStyles from "./styles";

export const SubscriptionListColumns = [
  {
    columnKey: "company_name",
    columnId: "company_name",
    columnHeader: "Company Name",
  },
  {
    columnKey: "facility_count",
    columnId: "facility_count",
    columnHeader: "No. of Facilities",
  },
  {
    columnKey: "start_date",
    columnId: "start_date",
    columnHeader: "Subscription Start Date",
  },
  {
    columnKey: "end_date",
    columnId: "end_date",
    columnHeader: "Subscription End Date",
  },
];

export const UsersListColumns = [
  {
    columnKey: "company",
    columnId: "company",
    columnHeader: "Company",
  },
  {
    columnKey: "users",
    columnId: "users",
    columnHeader: "Users",
  },
];

export const SubscriptionListColumnsWithAction = [
  {
    columnKey: "company_name",
    columnId: "company_name",
    columnHeader: "Company Name",
  },
  {
    columnKey: "facility_count",
    columnId: "facility_count",
    columnHeader: "No. of Facilities",
  },
  {
    columnKey: "start_date",
    columnId: "start_date",
    columnHeader: "Subscription Start Date",
  },
  {
    columnKey: "end_date",
    columnId: "end_date",
    columnHeader: "Subscription End Date",
  },
  {
    columnKey: "action",
    columnId: "action",
    columnHeader: "Action",
  },
];

export default function SuperAdminDashboardDetailsPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const classes = useStyles();

  const { type, filter } = useParams();
  const [statusType, setStatusType] = useState("");
  const [title, setTitle] = useState("");

  const [companyFilter, setCompanyFilter] = useState("");
  const [reformatedCompany, setReformatedCompany] = useState([]);
  const [subscriptionListCol, setsubscriptionListCol] = useState(
    SubscriptionListColumns.slice()
  );

  useEffect(() => {
    if (!filter) return;

    // Common updates
    let status = "";
    let title = "";
    let updatedCols = [];

    // User Filters
    if (filter === "totalUsers") {
      status = "total";
      title = "Total Users";
      UsersListColumns[1]["columnHeader"] = `Total Number of Users`;
    } else if (filter === "inactiveUsers") {
      status = "inactive";
      title = "Inactive Users";
      UsersListColumns[1]["columnHeader"] = `Total Number of Inactive Users`;
    } else if (filter === "lockedUsers") {
      status = "locked";
      title = "Locked Users";
      UsersListColumns[1]["columnHeader"] = `Total Number of Locked Users`;
    } else if (filter === "disabledUsers") {
      status = "disabled";
      title = "Disabled Users";
      UsersListColumns[1]["columnHeader"] = `Total Number of Disabled Users`;
    } else if (filter === "readOnlyUsers") {
      status = "read_only";
      title = "Read Only Mode Users";
      UsersListColumns[1][
        "columnHeader"
      ] = `Total Number of Read Only Mode Users`;
    }

    // Subscription Filters
    if (filter === "active") {
      status = "active";
      title = "Active Subscription Company List";
    } else if (filter === "expireIn30Days") {
      status = "expire_in_30_days";
      title = "Subscription Expiring in 30 Days";
      updatedCols = [
        ...subscriptionListCol,
        { columnKey: "action", columnId: "action", columnHeader: "Action" },
      ];
    } else if (filter === "readOnlyMode") {
      status = "read_only_mode";
      title = "Read Only Accounts";
      updatedCols = [
        ...subscriptionListCol,
        {
          columnKey: "duration",
          columnId: "duration",
          columnHeader: "Read Only Access Duration",
        },
        {
          columnKey: "action",
          columnId: "action",
          columnHeader: "Action",
        },
      ];
    } else if (filter === "inGracePeriod") {
      status = "in_grace_period";
      title = "Ingrace Period Accounts";
      updatedCols = [
        ...subscriptionListCol,
        {
          columnKey: "duration",
          columnId: "duration",
          columnHeader: "Grace Period Duration",
        },
      ];
    } else if (filter === "cacelled") {
      status = "cacelled";
      title = "Deactivated Accounts";
    }

    setStatusType((prev) => (prev !== status ? status : prev));
    setTitle((prev) => (prev !== title ? title : prev));
    if (updatedCols.length > 0) {
      setsubscriptionListCol(updatedCols);
    }
  }, [filter]);

  useEffect(() => {
    if (type === "user") dispatch(superAdminUserOverviewDetails(statusType));
    else if (type === "company")
      dispatch(superAdminCompanyOverviewDetails(statusType));
  }, [dispatch, statusType]);

  const normalizeActiveUsers = (activeUsersList) => {
    const resultMap = new Map();
    if (activeUsersList) {
      for (const entry of activeUsersList) {
        const names = entry.company.split(",").map((c) => c.trim());
        const ids = Array.isArray(entry.company_id)
          ? entry.company_id
          : [entry.company_id];

        names.forEach((company, index) => {
          const id = ids[index] || null;
          const key = `${company}_${id}`;

          if (resultMap.has(key)) {
            resultMap.get(key).users += entry.users;
          } else {
            resultMap.set(key, {
              company,
              company_id: id,
              users: entry.users,
            });
          }
        });
      }
    }

    return Array.from(resultMap.values());
  };

  const activeUsersList =
    useSelector(
      (state) => state.superAdmin.superAdminUserOverviewDetails.data
    ) || [];
  const companyList =
    useSelector(
      (state) =>
        state.superAdmin.superAdminCompanyOverviewDetails.data
          ?.companies_response
    ) || [];

  useEffect(() => {
    if (type === "company")
      setReformatedCompany(
        companyList.map((item) => ({
          ...item,
          company_id: item.id,
          company: item.company_name,
          action: (
            <Typography
              style={{
                textDecoration: "underline",
                color: "#25aac3",
                padding: "3px",
              }}
              onClick={() =>
                navigate(`/companies/${item.id}/customer-management`, {
                  state: { fromInsights: true, filter, type },
                })
              }
            >
              Click Here
            </Typography>
          ),
        }))
      );
    else if (type === "user") {
      setReformatedCompany(activeUsersList);
    }
  }, [dispatch, activeUsersList, companyList]);

  const filteredData = companyFilter
    ? reformatedCompany.filter((row) => row.company_id === companyFilter)
    : reformatedCompany;

  return (
    <DashboardLayout>
      <Container maxWidth={false} sx={{ py: 4, px: 5 }}>
        {/* Flex wrapper */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="flex-start"
          mb={3}
        >
          <Box>
            <Select
              value={companyFilter}
              onChange={(e) => setCompanyFilter(e.target.value)}
              displayEmpty
              size="small"
              sx={{
                backgroundColor: "#fff",
                borderRadius: "8px",
                mb: 4,
                width: "220px",
              }}
            >
              <MenuItem value="">All Companies</MenuItem>
              {reformatedCompany.map((c) => (
                <MenuItem key={c.company_id} value={c.company_id}>
                  {c.company}
                </MenuItem>
              ))}
            </Select>
            <Typography
              variant="h6"
              fontWeight={600}
              mb={1}
              sx={{ textAlign: "left" }}
            >
              {title}
            </Typography>
          </Box>

          {/* Back button right */}
          <Button
            variant="outlined"
            onClick={() => navigate("/dashboard")}
            sx={{
              borderRadius: "12px",
              textTransform: "none",
              px: 4,
              borderColor: "#7B2D43",
              color: "#7B2D43",
              fontWeight: 500,
              "&:hover": {
                borderColor: "#7B2D43",
                backgroundColor: "transparent",
              },
            }}
            startIcon={<ArrowBack />}
          >
            Back
          </Button>
        </Box>

        {type === "company" ? (
          <Container className={classes.tableContainer}>
            <CeroTable
              columns={subscriptionListCol}
              hasMore={false}
              loading={false}
              data={filteredData}
            />
          </Container>
        ) : (
          <Container className={classes.tableContainer}>
            <CeroTable
              columns={UsersListColumns}
              hasMore={false}
              loading={false}
              data={filteredData}
              onSelectRow={(event) =>
                navigate(
                  `/dashboard/details/${event.company_id}/facilites/${statusType}`,
                  {
                    state: {
                      filter,
                      type,
                      title: `${title} > ${event.company}`,
                    },
                  }
                )
              }
            />
          </Container>
        )}
      </Container>
    </DashboardLayout>
  );
}
